module.exports = __webpack_public_path__ + "market/static/img/qc.1eb3778.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ques/qc.jpg
// module id = 8EeA
// module chunks = 1